module.exports = __webpack_public_path__ + "static/media/select-caret.d5ba546d.svg";